<template>
  <b-modal v-model="isShow" size="lg" centered title="YÊU CẦU HỖ TRỢ CHUYỂN GIAO DỮ LIỆU">
    <!-- <iframe src="/ngan-luong-term-and-condition/" /> -->
    <div class="term-all">
      <p>
        Bằng việc chấp thuận tại văn bản này, ĐVCNTT xác nhận đã được Vi Mô thông báo đầy đủ về việc
        dừng cung cấp dịch vụ trung gian thanh toán. Để đảm bảo quyền lợi kinh doanh và duy trì sự
        liên tục trong việc sử dụng các dịch vụ trung gian thanh toán, ĐVCNTT đề nghị, chỉ định và
        cho phép Vi Mô, thay mặt ĐVCNTT thực hiện các công việc sau đây:
      </p>
      <ol class="list-number">
        <li>
          Trích xuất và chuyển giao Dữ Liệu của ĐVCNTT sang cho: Công ty Cổ phần Cổng Trung Gian
          Thanh Toán Ngân Lượng, địa chỉ: Tầng 3, Tòa nhà VTC Online, số 18, đường Tam Trinh, Phường
          Tương Mai, TP Hà Nội, Việt Nam. Mã số doanh nghiệp: 0106001236 ("Ngân Lượng").
        </li>
        <li>
          Việc chuyển giao Dữ Liệu này được thực hiện dựa trên nhu cầu và lợi ích của ĐVCNTT nhằm
          mục đích để Ngân Lượng thực hiện quy trình liên hệ tới khách hàng nhằm thiết lập hồ sơ
          khách hàng, thực hiện thủ tục nhận biết khách hàng (KYC), ký hợp đồng và cung cấp các dịch
          vụ trung gian thanh toán cho ĐVCNTT ("Mục Đích").
        </li>
        <li>
          Vi Mô và Ngân Lượng được tự do thỏa thuận về việc chuyển giao Dữ Liệu, bao gồm không giới
          hạn phương thức, biện pháp, ứng dụng, thiết bị liên quan đến việc chuyển giao dữ liệu để
          đảm bảo tính bảo mật và an toàn theo quy định pháp luật về bảo mật thông tin.
        </li>
        <li>
          Phạm vi dữ liệu của ĐVCNTT được chuyển giao ("Dữ Liệu") bao gồm:
          <ul class="list-minus">
            <li>- Tên;</li>
            <li>- Địa chỉ;</li>
            <li>- Số điện thoại liên hệ;</li>
            <li>- Hình ảnh giấy phép kinh doanh;</li>
            <li>- Hình ảnh các giấy tờ kinh doanh có điều kiện (nếu có);</li>
            <li>- Hình ảnh các văn bản ủy quyền, cam kết (nếu có);</li>
            <li>- Hình ảnh giấy tờ tùy thân của người đại diện pháp luật, đại diện ký hợp đồng;</li>
            <li>- Hình ảnh địa điểm kinh doanh;</li>
            <li>- Trang kinh doanh, quảng cáo online: website, page… (nếu có);</li>
          </ul>
        </li>
      </ol>

      <p>ĐVCNTT xác nhận và đồng ý rằng:</p>
      <ul class="list-minus">
        <li>
          - Việc yêu cầu hỗ trợ chuyển giao Dữ Liệu của ĐVCNTT tại văn bản này là hoàn toàn tự
          nguyện và dựa trên nhu cầu thực tế của ĐVCNTT. ĐVCNTT cam kết sẽ không khiếu nại, khiếu
          kiện hoặc để xảy ra một vụ tranh chấp nào với Vi Mô liên quan đến việc Vi Mô thực hiện các
          công việc theo đề nghị của ĐVCNTT tại văn bản này.
        </li>
        <li>
          - Vi Mô không phải chịu trách nhiệm đối với rủi ro phát sinh từ việc chuyển giao này, trừ
          trường hợp do lỗi cố ý sử dụng thông tin sai Mục Đích nêu tại văn bản này.
        </li>
      </ul>
      <p>
        ĐVCNTT xác nhận đã đọc, hiểu rõ, chấp thuận chính sách bảo mật của Vi Mô, Ngân Lượng và nội
        dung của văn bản này.
      </p>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button class="w-100" variant="primary" @click="cancel()"> Tôi đã hiểu </b-button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: 'PopupTermCondition',
    data() {
      return {
        isShow: false,
      }
    },
    methods: {
      show() {
        this.isShow = true
      },
      hide() {
        this.isShow = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .term-all {
    // padding-left: 12px;
    max-height: calc(60vh);
    overflow-y: auto;

    // Force đồng đều font cho toàn bộ nội dung, tránh Bootstrap modal override
    &,
    * {
      // font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial,
      //   sans-serif !important;
      font-size: 14px !important;
      color: #444 !important;
      line-height: 1.6 !important;
    }

    p {
      margin-bottom: 1rem;
    }

    // CSS counter thủ công — Bootstrap-Vue modal reset list-style về none
    ol.list-number {
      counter-reset: ol-counter;
      list-style: none !important;
      padding-left: 0;
      margin-bottom: 1rem;

      > li {
        counter-increment: ol-counter;
        position: relative;
        padding-left: 28px;
        list-style: none !important;
        margin-bottom: 12px;

        &::before {
          content: counter(ol-counter) '.';
          position: absolute;
          left: 10px;
          top: 0;
          min-width: 24px;
          // font-weight: 500 !important;
        }
      }
    }

    ul {
      padding-left: 0;
      margin-bottom: 1rem;
      margin-top: 8px;

      &.list-minus {
        list-style: none !important;
        padding-left: 0;
        margin-top: 8px;

        > li {
          list-style: none !important;
          margin-bottom: 4px;
        }
      }
    }
  }

  :deep(.modal-content) {
    .modal-header {
      justify-content: center;
      .modal-title {
        font-size: 16px;
        padding: 0 20px;
        text-align: center;
      }
      .close {
        position: absolute;
        left: 0;
      }
    }
    .modal-footer {
      .btn-primary {
        border-radius: 8px;
        border-color: #2563eb;
        font-size: 20px;
      }
    }
  }
</style>
